const BUTTON_COLORS = ["#2471A3", "#8E44AD", "#E67E22", "#F1C40F", "#34495E"];

module.exports = { BUTTON_COLORS };
